import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import config from '../config.js';
import { parse as mapBiblatex, parseBibtex as mapBibtex } from '../mapping/index.js';
import { parse as parseValue } from './value.js';
import { required } from './constants.js';

function validate(entries, requirements) {
  var problems = [];

  var _iterator = _createForOfIteratorHelper(entries),
      _step;

  try {
    var _loop = function _loop() {
      var _step$value = _step.value,
          type = _step$value.type,
          label = _step$value.label,
          properties = _step$value.properties;

      if (type in requirements) {
        var missing = [];

        var _iterator2 = _createForOfIteratorHelper(requirements[type]),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var field = _step2.value;

            if (Array.isArray(field) && !field.some(function (field) {
              return field in properties;
            })) {
              missing.push(field.join('/'));
            } else if (typeof field === 'string' && !(field in properties)) {
              missing.push(field);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        if (missing.length) {
          problems.push([label, "missing fields: ".concat(missing.join(', '))]);
        }
      } else {
        problems.push([label, "invalid type: \"".concat(type, "\"")]);
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (problems.length) {
    throw new RangeError(['Invalid entries:'].concat(problems.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          label = _ref2[0],
          problem = _ref2[1];

      return "  - ".concat(label, " has ").concat(problem);
    })).join('\n'));
  }
}

function parseEntryValues(entry) {
  var output = {};

  if ('language' in entry.properties) {
    output.language = parseValue(entry.properties.language, 'language');
  }

  for (var property in entry.properties) {
    var value = entry.properties[property];

    if (value === '') {
      continue;
    }

    output[property] = parseValue(value + '', property, output.language);
  }

  return _objectSpread(_objectSpread({}, entry), {}, {
    properties: output
  });
}

export function parse(entries) {
  if (config.parse.strict) {
    validate(entries, required.biblatex);
  }

  return mapBiblatex(entries.map(parseEntryValues));
}
export function parseBibtex(entries) {
  if (config.parse.strict) {
    validate(entries, required.bibtex);
  }

  return mapBibtex(entries.map(parseEntryValues));
}